import axios from "axios";
import {apiServicesUrl} from "./baseUrl";
import { userAccessToken } from "../helpers";

export const addToWaitingRoom = (postData) => {
  return axios.post(`${apiServicesUrl}/waiting_room`, postData, {
    headers: {
      "Content-Type": "application/json",
      "accept": "application/json",
      "Authorization": `Bearer ${userAccessToken()}`,
    },
  });
};


export const fetchHighRiskPatientsInfoSingleMonth = async (
  account_id,
  location_id,
  month,year
) => {
  try {
    const response = await axios.get(
      // calculate-revenue-for-high-risk-patients/?account_id=1&location_id=1&month=1&year=2024
      `${apiServicesUrl}/calculate-revenue-for-high-risk-patients/?account_id=${account_id}&location_id=${location_id}&month=${month}&year=${year}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchHighRiskPatientsInfoSixMonth = async (
  account_id,
  location_id,
  month,year,last_n_months
) => {
  try {
    const response = await axios.get(
      // calculate-revenue-for-high-risk-patients/?account_id=1&location_id=1&month=1&year=2024
      `${apiServicesUrl}/calculate-revenue-for-high-risk-patients/?account_id=${account_id}&location_id=${location_id}&month=${month}&year=${year}&last_n_months=${last_n_months}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
